module.exports = __webpack_public_path__ + "static/media/11Demo Photo-ink-min.823aef1e.jpeg";